import { ChannelManager } from 'common/manager';
import { modifyData as modifyCouponsData } from 'organisms/CouponsLanding/utils/CouponUtils';

export const modifyData = (data, isLocalized, foodLines) => {
  return modifyCouponsData(data);
};

export const getPageData = (currPage, pageLimit, content = []) => {
  const pageCount = Math.ceil(content.length / pageLimit);
  if (currPage <= pageCount && Array.isArray(content) && content.length) {
    const startIndex = 0;
    const endIndex = currPage * pageLimit > content.length - 1 ? content.length : currPage * pageLimit;
    return content.slice(startIndex, endIndex);
  }
  return content;
};

export const getPageCount = (pageLimit, content = []) => Math.ceil(content.length / pageLimit);

export const getFinalContentData = (isLocalized, isLoggedIn, contentData) => {
  const finalContentData = [...contentData];
  !isLoggedIn &&
    !ChannelManager.isGoogle &&
    finalContentData.unshift({
      cardType: 'login',
    });
  !isLocalized &&
    finalContentData.unshift({
      cardType: 'store',
    });
  return finalContentData;
};
